import { getContainerTypes } from "../../productCommons/index.js";
import type { SupplierRetailerConnectionDiscountItemType } from "../supplierRetailerConnectionDiscountCommons.js";

export const isContainerDiscountApplicable = ({
  discount,
  productContainerType,
}: {
  discount: {
    deletedAt: Date | null;
    itemType: SupplierRetailerConnectionDiscountItemType | null;
  };
  productContainerType: string | null;
}) => {
  if (discount.deletedAt) return false;

  if (discount.itemType === "any") return true;

  return getContainerTypes(productContainerType).includes(
    discount.itemType ?? "",
  );
};
